// import TextField from '@components/atoms/TextField'
// import Modal from '@components/molecules/Modal'
import ConnectWithUsModal from '@components/organisms/ConnectWithUsModal'
// import PopUpBottom from '@components/organisms/PopUpBottom'
// import styled from '@emotion/styled'
import useWindowDimensions from '@hooks/useWindowDimensions'
import { useDisclosure } from '@nextui-org/react-latest'
// import { ContactVector } from '@public/static/icons/landingPageIcons/ContactVector'
import { StillHaveQuestions } from '@public/static/icons/still-have-questions-icon'
// import CreateSupport from '@services/api/support/createSupport'
import {
  BenefitsForCreatorsHeader,
  BenefitsForCreatorsSubHeader,
  // ContactContainer,
  // ContactLeft,
  // ContactRight,
  // ContactRightHeading,
  // ContactSubmitButton,
  ContactiWithSpecialist,
  // InputField,
  // InputFieldWrapper,
  StillHaveQuestionsGlobalWrapper,
  StillHaveQuestionsWrapper,
  // TextAreaField,
} from '@styled_components/home/styled.components'
import { useTranslation } from 'react-i18next'
// import * as Yup from 'yup'

type Props = {
  isBecomeAuthor?: boolean
}

// const Error = styled.p`
//   color: red;
//   text-align: left;
//   font-size: 12px;
// `

// const initialValues: SupportRequest = {
//   email: '',
//   country: '',
//   phone: '',
//   message: '',
// }

// const validationSchema = Yup.object({
//   email: Yup.string()
//     .email('Invalid email format')
//     .required('Email is required'),
//   country: Yup.string().required('Country is required'),
//   phone: Yup.number().required('Phone is required'),
//   message: Yup.string()
//     .min(50, 'Message must be at least 50 characters')
//     .required('Message is required'),
// })

const ConnectWithUs = ({ isBecomeAuthor = false }: Props) => {
  const { width } = useWindowDimensions()
  const { t } = useTranslation(['landingPage'])
  const { isOpen, onOpen, onOpenChange } = useDisclosure()
  // const [toggleContact, setToggleContact] = useState<boolean>(false)
  // const [bottomNotification, setBottomNotification] = useState<
  //   boolean | BottomNotification
  // >(false)

  // const handleSubmit = async (data: SupportRequest, { resetForm }) => {
  //   // if (authState.firebaseUser) {
  //   // const tokenId = await authState.firebaseUser.getIdToken(false)
  //   CreateSupport({ ...data })
  //     .then(() => {
  //       setBottomNotification({
  //         message: 'Submitted successfully!',
  //         actionType: 'success',
  //       })
  //       resetForm()
  //     })
  //     .catch(() =>
  //       setBottomNotification({
  //         message: 'Something went wrong!',
  //         actionType: 'error',
  //       })
  //     )
  //   // }
  // }
  return (
    <>
      <StillHaveQuestionsGlobalWrapper className={isBecomeAuthor && '!p-0'}>
        <StillHaveQuestionsWrapper
          style={{
            height: 'auto',
            marginTop: 70,
            display: 'flex',
            flexDirection: (width || 0) < 810 ? 'column' : 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '8%',
            width: '100% !imporant',
          }}
        >
          <div style={{ flex: 1 }}>
            <StillHaveQuestions></StillHaveQuestions>
          </div>
          <div
            style={{
              flex: 1.2,
              display: 'flex',
              flexDirection: 'column',
              marginTop: 20,
              alignItems: (width || 0) < 810 ? 'center' : 'flex-start',
            }}
          >
            <BenefitsForCreatorsHeader
              style={{
                color: 'white',
                textAlign: (width || 0) < 810 ? 'left' : 'left',
              }}
            >
              {t('stillHaveQuestions', { ns: 'landingPage' })}
            </BenefitsForCreatorsHeader>
            <BenefitsForCreatorsSubHeader
              style={{
                color: 'white',
                textAlign: (width || 0) < 810 ? 'center' : 'left',
              }}
            >
              {t('connectWithEduSpecialistAndGetAnswers', {
                ns: 'landingPage',
              })}
            </BenefitsForCreatorsSubHeader>
            <ContactiWithSpecialist
              // onClick={() => onOpen()}
              onClick={() => onOpen()}
              style={{ marginBottom: 20 }}
            >
              {t('connectWithEduSpecialist', {
                ns: 'landingPage',
              })}
            </ContactiWithSpecialist>
          </div>
        </StillHaveQuestionsWrapper>
      </StillHaveQuestionsGlobalWrapper>
      <ConnectWithUsModal isOpen={isOpen} onOpenChange={onOpenChange} />
      {/* {toggleContact && (
        <Modal
          onClose={() => setToggleContact(false)}
          width="46rem"
          mdWidth="70%"
        >
          <ContactContainer color="white" toggle={toggleContact}>
            <ContactLeft>
              <ContactVector />
            </ContactLeft>
            <ContactRight>
              <ContactRightHeading>
                {t('How can we connect with you?')}
              </ContactRightHeading>

              <Formik
                initialValues={initialValues}
                onSubmit={handleSubmit}
                validationSchema={validationSchema}
              >
                <Form>
                  <InputFieldWrapper>
                    <InputField>
                      <TextField
                        type="text"
                        id="country"
                        name="country"
                        padding="0px 16px"
                        placeholder="Country"
                      />
                      <Error>
                        <ErrorMessage name="country" />
                      </Error>
                    </InputField>
                    <InputField>
                      <TextField
                        type="email"
                        id="email"
                        name="email"
                        padding="0px 16px"
                        placeholder="Email"
                      />
                      <Error>
                        <ErrorMessage name="email" />
                      </Error>
                    </InputField>
                    <InputField>
                      <TextField
                        type="number"
                        id="phone"
                        name="phone"
                        padding="0px 16px"
                        placeholder="Mobile Phone"
                      />
                      <Error>
                        <ErrorMessage name="phone" />
                      </Error>
                    </InputField>

                    <Field name="message">
                      {({ field, meta }) => (
                        <div>
                          <TextAreaField
                            width="20rem"
                            type="text"
                            placeholder="Message"
                            {...field}
                          />
                          {meta.touched && meta.error && (
                            <p style={{ textAlign: 'center' }}>
                              <Error>
                                <ErrorMessage name="message" />
                              </Error>
                            </p>
                          )}
                        </div>
                      )}
                    </Field>
                    <ContactSubmitButton type="submit">
                      {t('Submit')}
                    </ContactSubmitButton>
                  </InputFieldWrapper>
                </Form>
              </Formik>
            </ContactRight>
          </ContactContainer>
          {bottomNotification && (
            <PopUpBottom
              bottomNotification={bottomNotification as BottomNotification}
              setShowPopUp={setBottomNotification}
            />
          )}
        </Modal>
      )} */}
      {/* <ContactContainerWrapper toggle={toggleContact}> */}
      {/* </ContactContainerWrapper> */}
    </>
  )
}

export default ConnectWithUs
